export default {
    SOCKET_CONNECT_START: "SOCKET_CONNECT_START",
    SOCKET_CONNECT_SUCCESS: "SOCKET_CONNECT_SUCCESS",
    SOCKET_CONNECT_ERROR: "SOCKET_CONNECT_ERROR",
};
